import { WorkerDetail } from '@/services/workersV2API';

type WorkerStatusSubject = Pick<
  WorkerDetail,
  'active' | 'is_suspended' | 'suspension_type'
>;

export const getAccountStatusLabel = (worker: WorkerStatusSubject) =>
  worker.active ? 'Active' : 'Inactive';

export const getAccountStatusBadgeStatus = (worker: WorkerStatusSubject) =>
  worker.active ? 'theme' : 'danger';

export const getSuspensionStatusLabel = (worker: WorkerStatusSubject) => {
  if (!worker.is_suspended) return 'Not Suspended';

  return worker.suspension_type === 'permanent'
    ? 'Permanently Suspended'
    : 'Temporarily Suspended';
};

export const getSuspensionStatusBadgeStatus = (worker: WorkerStatusSubject) =>
  worker.is_suspended ? 'danger' : 'neutral';
